import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import api from 'utils/api';
import { getSelectedSalonId } from 'utils/salon';

const SummaryMetrics = ({ metrics }) => {
  const navigate = useNavigate();
  const [employeeCount, setEmployeeCount] = React.useState(null);
  const [serviceCount, setServiceCount] = React.useState(null);
  const [todayAppointments, setTodayAppointments] = React.useState(null);
  const formatPersianNumber = (num) => {
    const persianDigits = '۰۱۲۳۴۵۶۷۸۹';
    return num?.toString()?.replace(/\d/g, (digit) => persianDigits?.[digit]);
  };

  const salonId = getSelectedSalonId();

  const getNumberofEmployees = async (salonId) => {
    console.log('Fetching number of employees for salonId:', salonId);
    try {
      const res = await api.get(`/salons/${salonId}/employees`);
      const employees = Array.isArray(res.data) ? res.data : res.data?.employees || [];
      console.log('Number of employees fetched:', employees.length);
      setEmployeeCount(employees.length);
      return employees.length;
    } catch (error) {
      console.error('Error fetching employees:', error);
    }
    // This function should return the number of employees for the given salonId
    // For now, we'll return a placeholder value
  };

  const getNumberOfServices = async (salonId) => {
    try {
      const res = await api.get(`/salons/${salonId}/services`);
      const services = Array.isArray(res.data) ? res.data : res.data?.services || [];
      setServiceCount(services.length);
      return services.length;
    } catch (error) {
      console.error('Error fetching services:', error);
      return 0;
    }
  };

  const getNumberOfTodaysAppointments = async (salonId) => {
    try {
      const today = new Date().toISOString().slice(0, 10);
      const res = await api.get(`/salons/${salonId}/bookings?date=${today}`);
      const appointments = Array.isArray(res.data) ? res.data : res.data?.bookings || [];
      setTodayAppointments(appointments.length);
      return appointments.length;
    } catch (error) {
      console.error("Error fetching today's appointments:", error);
      return 0;
    }
  };

  useEffect(() => {
    getNumberofEmployees(salonId);
    getNumberOfServices(salonId);
    getNumberOfTodaysAppointments(salonId);
  }, [salonId]);

  const metricCards = [
    {
      title: 'کارمندان فعال',
      value: employeeCount,
      icon: 'Users',
      color: 'text-success',
      bgColor: 'bg-success/10',
      change: '+۵',
      changeType: 'increase',
      route: '/employee-management',
    },
    {
      title: ' سرویس های فعال',
      value: serviceCount,
      icon: 'Scissors',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      change: '+۳',
      changeType: 'increase',
      route: '/service-management',
    },
    {
      title: 'نوبت‌های امروز',
      value: todayAppointments,
      icon: 'Calendar',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      change: '+۱۲',
      changeType: 'increase',
      route: '/booking-management',
    },
  ];

  const handleCardClick = (route) => {
    navigate(route);
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
      {metricCards?.map((metric, index) => (
        <div
          key={index}
          onClick={() => handleCardClick(metric?.route)}
          className="bg-card border border-border rounded-lg p-6 hover:shadow-elevation-1 transition-all duration-200 cursor-pointer hover:border-primary/50"
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              handleCardClick(metric?.route);
            }
          }}>
          <div className="flex items-center justify-between mb-4">
            <div
              className={`w-12 h-12 rounded-lg ${metric?.bgColor} flex items-center justify-center`}>
              <Icon name={metric?.icon} size={24} className={metric?.color} />
            </div>
            <div className="text-right">
              <div className="text-2xl font-bold text-foreground">
                {metric?.value === null || metric?.value === undefined
                  ? '…'
                  : formatPersianNumber(metric.value)}
              </div>
              <div className="text-sm text-muted-foreground">
                {metric?.title}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SummaryMetrics;
